import React from 'react';

import TopbarContainer from '../TopbarContainer/TopbarContainer';

import css from './LandingHeader.module.css';

const LOGO_PATH = '/static/logos/throttlex-logo.png';

const LandingHeader = () => {
  return (
    <div className={css.stickyHeader}>
      <div className={css.primaryRow}>
        <a href="/" className={css.logoLink} aria-label="ThrottleX homepage">
          <img src={LOGO_PATH} alt="ThrottleX" className={css.logoImage} />
        </a>

        <nav className={css.primaryNavigation} aria-label="Homepage navigation">
          <a href="/s">Browse</a>
          <a href="#categories">Categories</a>
          <a href="#marketplace-preview">Listings</a>
          <a href="#how-it-works">How it works</a>
          <a href="#hosting">List your vehicle</a>
        </nav>

        <div className={css.navigationSpacer} aria-hidden="true" />
      </div>

      <div className={css.secondaryRow}>
        <TopbarContainer
          currentPage="LandingPage"
          rootClassName={css.topbarRoot}
        />
      </div>
    </div>
  );
};

export default LandingHeader;